<app-header></app-header>
<main>
	<div class="main-container">
		<div class="container">
			<div class="row justify-content-sm-center ">
				<div class="col-xs-12 col-sm-7 col-md-6 col-lg-5">
					<app-title></app-title>
					<router-outlet name="help"></router-outlet>
				</div>
			</div>
			<div class="row justify-content-sm-center ">
				<div class="col-xs-12 col-sm-7 col-md-6 col-lg-5">
					<router-outlet name="message"></router-outlet>
				</div>
			</div>
		</div>
	</div>
</main>
